// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsRedshiftClustersIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-redshift-clusters_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M25.91 17.59a.96.96 0 1 1 0-1.92.96.96 0 0 1 0 1.92m-2.43 5.82a.96.96 0 1 1 0-1.92.96.96 0 0 1 0 1.92m-5.84-.97a.96.96 0 1 1 0-1.92.96.96 0 0 1 0 1.92m-2.43 5.34a.96.96 0 1 1 0-1.92.96.96 0 0 1 0 1.92m10.7-13.1a1.95 1.95 0 0 0-1.12 3.55l-.91 2.31a1.95 1.95 0 0 0-2.24 1.29l-2.05-.47a1.95 1.95 0 1 0-3.4 1.43l-.89 2.09-.09-.01a1.96 1.96 0 1 0 1.05.31l.79-1.84q.28.1.6.1c.76 0 1.42-.45 1.74-1.1l2.17.5a1.96 1.96 0 0 0 3.88-.38c0-.59-.26-1.1-.67-1.46l.96-2.43.18.01a1.96 1.96 0 1 0 0-3.9M20.5 33c-4.86 0-8.5-1.46-8.5-2.76V11.59c1.66 1.34 5.15 2.05 8.5 2.05s6.84-.71 8.5-2.05v18.65c0 1.3-3.64 2.76-8.5 2.76m0-26c5 0 8.5 1.48 8.5 2.82s-3.5 2.82-8.5 2.82S12 11.15 12 9.82C12 8.48 15.5 7 20.5 7M30 9.82C30 7.34 25.1 6 20.5 6S11 7.34 11 9.82v20.41c0 2.45 4.9 3.77 9.5 3.77s9.5-1.32 9.5-3.76V9.82"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-redshift-clusters_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsRedshiftClusters",
);
export default AwsRedshiftClustersIcon;
